import { cardImageSources, type GenericCharacter } from './types'

export const genericPirata: GenericCharacter = {
  id: 'generic-pirata',
  enabled: true,
  order: 11,
  displayName: 'Capitana Marina',
  icon: '⚓',
  imageSources: cardImageSources('generic-pirata'),
}
